export const state = {
    itemsPerPage: 10,
}

export const getters = {
    itemsEgpPerPage: state => state.itemsPerPage
}

export const mutations = {
    setItemsPerPage(state, value){
        state.itemsPerPage = value
    }
}

export const actions = {
    setItemsPerPage({commit}, value){
        commit("setItemsPerPage", value)
    }
}